import { tax_id_types } from 'lib/constants/constants';

import SectionList from 'components/practice/UserPreferences/components/SectionList';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

const ClearingHouseSection = ({ formik }) => {
  return (
    <div>
      <SectionList
        title="Clearing House"
        description="Provide the required identifiers for billing and clearing house registration to ensure
          accurate claim processing."
      />
      <div className="grid grid-cols-2 gap-3">
        <Input
          name="npi"
          value={formik.values.npi}
          onChange={formik.handleChange}
          label="NPI"
          placeholder="Enter NPI"
          error={formik.errors.npi}
        />
        <Input
          name="tax_id"
          value={formik.values.tax_id}
          onChange={formik.handleChange}
          label="Tax ID"
          placeholder="Enter tax ID"
          error={formik.errors.tax_id}
        />
        <Select
          name="tax_id_type"
          value={
            formik.values.tax_id_type && {
              label: tax_id_types.find((t) => t.value === formik.values.tax_id_type)?.label
            }
          }
          onChange={(option) => formik.setFieldValue('tax_id_type', option?.value)}
          options={tax_id_types}
          error={formik.errors.tax_id_type}
          label="Tax ID type"
          placeholder="Select tax ID type"
        />
        <Input
          name="taxonomy"
          value={formik.values.taxonomy}
          onChange={formik.handleChange}
          label="Taxonomy"
          placeholder="Enter taxonomy"
          error={formik.errors.taxonomy}
        />
      </div>
    </div>
  );
};

export default ClearingHouseSection;
